import '../sass/main.scss'
import App from './App.svelte'

const app = new App({ target: document.getElementById('leads'), 
    props: {
        region: document.getElementById('leads').getAttribute('data-region')
    }
})

export default app
